// import React, { Component } from 'react';

// export default class DownloadsGrid extends Component {
//   static propTypes = {

//   };

//   render() {
//     return (
//       <div className="downloads-downloads-grid">
//         Component content: downloads/DownloadsGrid
//       </div>
//     );
//   }
// }
import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import tileData from '../../common/tileData';
import Tile from '../common/Tile';
import InfoTile from '../common/InfoTile';
import { Button } from 'semantic-ui-react'


export default class DownloadsGrid extends Component {
  static propTypes = {

  };

  render() {
    const data = tileData.downloads;
   
    
    return (
      <Grid className="page-grid about-us-about-us-grid" columns="equal">
        <Grid.Row stretched>
          <Grid.Column largeScreen={16} mobile={16} tablet={16}>
            {/* Main tile  backgroundColor="#f4f4f4" */}
            <InfoTile
              backgroundColor="#db1689"
              title={data[0].title}
            >
              
            </InfoTile>
            <div className="download-button">
              <a className="" href='https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/pdfs%2FReglamento%20interno.pdf?alt=media&token=99c1b833-89a8-4e2e-a443-7cd70ae83d70' download="Reglamento.pdf">
              <Button primary>Download</Button>
              </a>
            </div>
           
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched>
          <Grid.Column largeScreen={16} mobile={16} tablet={16}>
            {/* Services */}
            <InfoTile
              backgroundColor="#fcba03"
              title={data[1].title}
            />
              {/* <Button primary>{data[1].description}</Button> */}
              <div className="download-button">
              <a className="" href='https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/pdfs%2FMinimalist%20Simple%20Client%20Services%20Welcome%20Packet%20(1).pdf?alt=media&token=cad987f3-cd1d-46b0-8024-15c3ba5f714f' download="Servicios.pdf" >
              <Button primary>Download</Button>
              </a>
            </div>

          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/downloads/DownloadsGrid.js